import React from 'react';
import axios2 from 'services/axios2';

import {useParams} from 'react-router-dom';
import {Link,hashHistory} from 'react-router-dom';
import { ToastContainer, toast } from 'react-toastify';
import { NuDropdown } from 'components/nubox/NuDropdown';

import { withRouterJim } from "router/withRouterJim";
import NuConfirm from "components/nubox/Box/NuConfirm";
import ModalAsistencia from './ModalAsistencia'

import user from 'assets/img/user.jpg';

import { NotificationContainer, NotificationManager } from 'react-notifications';
import {
  Table,
  Button,
} from 'reactstrap';

const data = [
  //{ id_medico: 1,  nombre: 'ALEX LIZARRAGA',  especialidad: '00000023',tel:''}, 
];
/*$$$$$$$$$$$$$$$$$$$$$$$$$$$$$$$$$$$$$$$$$$$$$$$$$$$$$$$$$$$$$$$$$$$$$$$*/
class Asistencia2List extends React.Component {  

  modalRef = React.createRef();//create ref
  
  state = {
    modalInsertar: false,
    form: {
      ver_sn_new: 0,
    },
    data: data,/* lista de datos */
    
  };
  //--------------------------------------
  constructor(props) {
    super(props);

    this.refNuConfirm = React.createRef();
  }
  //------------------
  //------------------------------------------------------
  componentDidMount() {
    //--limpiamos el array de datos
    this.setState({data:[]});

    this.cargar_data();
    
    //this.cargar_citas();
    console.log(this.modalRef);
  }
  //----------------especial, actualiza valores del form -------------------------------
  handleChangeForm = (e) => {
    //requerimos la prop name="?" en cada control
    
    //--- esto lo hacemos porque en vez de utilizar valores true, false
    //--- tenemos que utilizar 1, 0
    if(e.target.type==="checkbox"){
      //console.log("cheched:"+ e.target.checked);
      let res = e.target.checked? 1:0;
      //console.log("value:"+ res);
      
      this.setState({
        form:{
          ...this.state.form,
          [e.target.name]: res,
        }
      })
    }else{
      this.setState({
        form: {
          ...this.state.form,
          [e.target.name]: e.target.value,
        },
      });
    }
  };
  //====================================================== 
  cargar_data = () => {
    let materia = this.props.store.materia
    let user = this.props.store.user

    let param = { 
      id_doc: user.id_doc,
      id_mate: materia.id_mate,
      id_peri: user.id_peri,
    }
    console.log(param)
    axios2.post( 'asistencia2_fecha_get_list', param)
    .then(res => {
        console.log(res.data);

        if(res.data.coleccion.length>0){ 
            this.setState({data: res.data.coleccion});
        }else{
            NotificationManager.error('No existen datos');
        }

    }).catch(error => {
        alert('---- Existio un error. ---');
        console.log(error);
        
    });
  };
  //======================================================     
  imprimir =(id_certi)=>{
    let fileURL = process.env.REACT_APP_API_URL  + 'certificado_reciboPDF/'+ id_certi;
    let  windowFeatures = 'width=650,height= 700, left=100,top=100 ';
    window.open(fileURL,'',windowFeatures);
  }
  /* === This is where the magic happens ==== */
  handleSubmit = event => {
    event.preventDefault();
    this.cargar_data();
  }
  //-----------------------------------------------------------------
  nuevo = () => {
    let materia = this.props.store.materia
    let user = this.props.store.user

    this.modalRef.current.nuevo(materia.id_mate, user.id_peri);
  }
  //-----------------------------------------------------------------
  editar = (item) =>{
    console.log('editar');
    //    console.log(item);
    let idd = item.id_asisfe;
    this.modalRef.current.editar(idd);
  }
  //-----------------------------------------------------------------
  eliminar = (item) =>{
    console.log('eliminar');
    
    this.refNuConfirm.current.show({
      message: 'Esta seguro de eliminar?',
      title: 'Confirmar',
      icon: 'fa fa-question-circle',
      classHeader: 'bg-default1 ',
      classButton: 'btn btn-danger',
      accept: () => {
        let idd = item.id_asisfe;
        this.modalRef.current.eliminar(idd);
      },
      reject: () => {
          console.log('cancel');
      },
      acceptLabel: 'Aceptar',
      rejectLabel: 'Cancelar'
    })

  }
  //-------------------------------------
  okModal =()=>{
    console.log('citaOkModal');
    this.cargar_data();
  }
  //-------------------------------------
  closeModal =()=>{
    console.log('citaCancelModal');
  }
  //-------------------------------------
  render() {
    let materia = this.props.store.materia
    let user = this.props.store.user

    return (
      <div>
        
        <div className='content'>

          {/*{/*--- -----------------------------*/}
          <div className='row'>
            <div className='col-md-12'>
              <h3> Listado de fechas de asistencias</h3>
          </div>

          <div className='row d-flex justify-content-center'>
              <div className='box box-info' style={{ padding: '5px 10px 5px 10px', width: '300px' }}>
                {/*-- box-header --*/}
                <div className='box-body pad'>

                  <form onSubmit={this.handleSubmit}>

                      <table>
                        <tbody>
                          <tr>
                            <td><span className="text-muted">Periodo:</span></td>
                            <td>{ user.periodo }</td>
                          </tr>
                          <tr>
                            <td><span className="text-muted">Materia:</span></td>
                            <td>{ materia.nombre }  </td>
                          </tr>
                          <tr>
                            <td colSpan="3">
                              {/*
                              Habilitar asistencia via web
                                <input 
                                  name="ver_sn_new" 
                                  type="checkbox" 
                                  value = {this.state.form.ver_sn_new }
                                  checked={this.state.form.ver_sn_new===1 }
                                  onChange={this.handleChangeForm}  
                                />
                              */}

                            </td>
                          </tr>
                          <tr>

                            <td>
                              {/*<Button id="btn_buscar" className="btn btn-warning btn-sm">
                                <i className="fa  fa-bolt" aria-hidden="true"></i>  Actualizar
                              </Button>
                              */}
                            </td>
                          </tr>
                          <tr>
                            <td colSpan="3"><div id="divres1"></div></td>
                          </tr>
                        </tbody>
                      </table>

                  </form>

                </div>
                {/* box-body */}
              </div>


              {/*-- box table */}
              <div className='box'>

                <div className='box-body'>
                  <div className='top_title2'>
                    <div className='row'>
                      <div className='col-md-12'>
                        
                      
                        <div className=' pull-right'>

                          <Button onClick={() => this.nuevo()} 
                            className='create-modal btn btn-info ' >
                            <i className='fa fa-plus'></i> Nuevo 
                          </Button>
                        </div>
                        <h4>Fechas</h4>
                      </div>
                    </div>
                  </div>
                  {/*-- */}
                  <table className='table table-striped table-hover' width='100%' align='center'>
                    <thead>
  
                      <tr>
                      <th>Cod. </th>
                      <th>Materia</th>
                      <th>Fecha</th>
                      <th>Detalle.</th>
                      <th>Acción</th>
                      </tr>

                    </thead>
                    <tbody>
                      {/* className='text-left' */}
                      
                      {this.state.data.map((item, index) => (
                        <tr key={index}> 
                          <td>{ item.id_asisfe}</td>
                          <td>{ item.id_mate}</td>
                          <td>{ item.fecha}</td>
                          <td>{ item.detalle}</td>

                          <td>
                            <div className='btn-group'>
                              <Button className='btn btn-warning btn-sm' title='Editar' 
                                onClick={() => this.editar(item)}>
                                <i className='fa fa-edit'></i>
                              </Button>
                              &nbsp;
                              <Button className='btn btn-danger btn-sm' title='Eliminar' 
                                onClick={() => this.eliminar(item)}  >
                                <i className='fa fa-trash'></i>
                              </Button>
                              &nbsp;
                              <Link to={`/asistencia2/${item.id_asisfe}`} className="btn btn-info btn-sm">
                                <i className="fa fa-eye"></i>
                              </Link>
                            </div>
                          </td>
                        </tr>
                      ))}



                    </tbody>
                  </table>
                  {/*-- */}
                </div>


                <ModalAsistencia
                  ref={this.modalRef}
                  okModal={this.okModal}
                  closeModal={this.closeModal}
                />

              </div>
            </div>
          </div>
        </div>

        <ToastContainer />
        <NuConfirm   ref={ this.refNuConfirm }    />
      </div>
    );
  }
}
//------------para que soporte la funcionalidad de parametros
export default withRouterJim(Asistencia2List);
